import {ApiParams, StateId} from '@wallaby-ui/core';
import {forEach, forOwn, keys, omit, pick} from 'lodash';
import {createSelector} from 'reselect';

import {RootState} from 'src/js/store';

interface SelectorProps {
  filterAndSearchStateId?: StateId;
  searchServiceUrl: string;
  serviceUrls: any;
}

const getCaseTypeStateSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'filterAndSearchStateId'>
) => state[props?.filterAndSearchStateId].queryParameters.caseType;

const getComponentsLoadedSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'filterAndSearchStateId'>
) => state[props?.filterAndSearchStateId].componentsLoaded;

const getSearchServiceUrlStateSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'filterAndSearchStateId'>
) => state[props?.filterAndSearchStateId].serviceUrls.searchService;

const getSearchServiceUrlParamsSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'searchServiceUrl'>
) => props.searchServiceUrl;

const getServiceUrlsStateSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'filterAndSearchStateId'>
) => state[props?.filterAndSearchStateId].serviceUrls;

const getApiParametersSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'filterAndSearchStateId'>
) => state[props?.filterAndSearchStateId]?.apiParameters;

const getServiceUrlsPropsSelector = (
  state: RootState,
  props: Pick<SelectorProps, 'serviceUrls'>
) => props.serviceUrls;

export const getCaseType = createSelector(
  [getCaseTypeStateSelector],
  (caseType) => caseType
);

export const getSearchServiceUrl = createSelector(
  [getSearchServiceUrlStateSelector, getSearchServiceUrlParamsSelector],
  (stateUrl, paramUrl) => stateUrl || paramUrl
);

// TODO: non-memoized selector
export const getServiceUrlsPropsSelectorByStateKeys = createSelector(
  [getServiceUrlsStateSelector, getServiceUrlsPropsSelector],
  (stateUrl, paramUrl) => pick(paramUrl, keys(stateUrl))
);

// TODO: non-memoized selector
export const getServiceUrls = createSelector(
  [getServiceUrlsStateSelector, getServiceUrlsPropsSelectorByStateKeys],
  (stateUrl, paramUrl) => {
    const resultObject = {};
    forEach(keys(stateUrl), (property) => {
      resultObject[property] = stateUrl[property] || paramUrl[property];
    });

    return resultObject;
  }
);

export const getFlattenApiParametersSelector = createSelector(
  [getApiParametersSelector],
  (apiParameters: ApiParams) => ({
    ...omit(apiParameters, ['filterMap']),
    ...apiParameters?.filterMap,
  })
);

export const areAllComponentsLoaded = createSelector(
  [getComponentsLoadedSelector],
  (componentsLoaded) => {
    let result = true;
    forOwn(componentsLoaded, (property) => {
      if (!property) {
        result = false;
      }
    });
    return result;
  }
);
